import { BaseMessenger } from "chatkit-web-shared/BaseMessenger"
import { InnerCommands, InnerEvents, OuterCommands, OuterEvents } from "chatkit-web-shared/types"

export class ChatFrameMessenger extends BaseMessenger<
  OuterCommands,
  InnerCommands,
  OuterEvents,
  InnerEvents
> {}
